import styled from "styled-components"
import { NavLink } from "react-router-dom"

export const StyledNavLink = styled(NavLink)`
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
